import { render, staticRenderFns } from "./RelatorioCargaDescargaListFiltroModalItemInputTransportadora.vue?vue&type=template&id=8785ea56"
import script from "./RelatorioCargaDescargaListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"
export * from "./RelatorioCargaDescargaListFiltroModalItemInputTransportadora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports